import {fetchAtClientSide} from "../utils/misc/fetchClient";
import {UserIdentity} from "../interfaces";

export const getUserData = async (): Promise<UserIdentity | Error> => {
    const url = `members/0?expand=bookmarkCount&viewsCount&commentCount&rating&foallowingsCount&followersCount&is_followed&viewsa`;
    return fetchAtClientSide<UserIdentity | Error>({url, shouldRetry: false});
};
